// extracted by mini-css-extract-plugin
module.exports = {"sensorValueSeparator":"StreamingValueChip_sensorValueSeparator__3dSnC","displayBlockMultipleValues":"StreamingValueChip_displayBlockMultipleValues__26HMX"};